export default function getFieldValue(name, values) {
  return [values, ...name.split(".")].reduce(
    (accumulator, currentValue) => accumulator[currentValue]
  );
}
